<template>
  <div class="min-h-screen flex flex-row bg-white">
    <div
        class="flex flex-col w-72 bg-gray-100 rounded-tr-2xl overflow-hidden h-screen"
    >
      <!--
      <div class="flex items-center justify-center h-20 shadow-md" :class="$store.state.vueAppStandAlone ? '' : 'hidden'">
          <h1
              @click.prevent="openLink('/')"
              class="link text-3xl text-themeColor font-bold"
          >
              {{ $t('navbar.company') }}
          </h1>
      </div>
-->
      <ul class="flex flex-col py-4">
        <label class="pl-5 pt-4 pb-2 text-gray-500 font-semibold">{{
            $t('navbar.posts')
          }}</label>
        <li
            id="linkNewPost"
            @click.prevent="openLink('/')"
            class="link flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover-text-themeColor"
        >
                    <span
                        class="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"
                    ><i class="fas fa-plus-circle"></i
                    ></span>
          <span class="text-sm font-medium">{{
              $t('navbar.new_post')
            }}</span>
        </li>
        <li
            v-if="isConnected || weakConnection"
            @click.prevent="openLink('/tickets')"
            class="link flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover-text-themeColor"
        >
                    <span
                        class="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"
                    >
                        <i class="fas fa-list-ul"></i>
                    </span>
          <span class="text-sm font-medium flex-grow">{{
              $t('navbar.my_posts')
            }}</span>
          <span class="w-12">
                        <b-tag
                            type="is-danger"
                            v-if="unread_messages && unread_messages > 0"
                        >
                            {{ unread_messages }}
                        </b-tag>
                    </span>
        </li>
        <label
            v-if="isConnected"
            class="pl-5 pt-4 pb-2 text-gray-500 font-semibold"
        >{{ $t('navbar.account') }}</label
        >
        <li
            v-if="isConnected"
            @click.prevent="openLink('/mon-compte')"
            class="link flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover-text-themeColor"
        >
                    <span
                        class="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"
                    ><i class="fas fa-user"></i
                    ></span>
          <span class="text-sm font-medium">{{
              $t('navbar.my_account')
            }}</span>
        </li>
        <label
            v-if="!isConnected"
            class="pl-5 pt-4 pb-2 text-gray-500 font-semibold"
        >{{ $t('navbar.actions') }}</label
        >
        <li
            v-if="!isConnected"
            @click.prevent="openLink('/login')"
            class="link flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover-text-themeColor"
        >
                    <span
                        class="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"
                    ><i class="fas fa-lock-open"></i
                    ></span>
          <span class="text-sm font-medium">{{
              $t('navbar.register')
            }}</span>
        </li>
        <li
            v-if="!isConnected"
            @click.prevent="openLink('/register')"
            class="link flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover-text-themeColor"
        >
                    <span
                        class="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"
                    ><i class="fas fa-user-lock"></i
                    ></span>
          <span class="text-sm font-medium">{{
              $t('navbar.new_account')
            }}</span>
        </li>
        <li>
          <a
              href="#"
              @click.prevent="doLogout"
              v-if="isConnected"
              class="link flex flex-row items-center h-12 transform hover:translate-x-2 transition-transform ease-in duration-200 text-gray-500 hover-text-themeColor"
          >
                        <span
                            class="inline-flex items-center justify-center h-12 w-12 text-lg text-gray-400"
                        ><i class="fas fa-sign-out-alt"></i
                        ></span>
            <span class="text-sm font-medium">{{
                $t('navbar.disconnect')
              }}</span>
          </a>
        </li>
        <li v-if="isMessagingSupported">
          <b-field
              class="flex ml-2 flex-row items-center h-12 text-gray-500 hover-text-themeColor"
          >
            <b-switch
                v-model="isSwitched"
                @input="updateIsPushNotif()"
                class="text-sm font-medium"
                type="is-primary"
            >{{
                $t('post.page.notifications.subscription')
              }}
            </b-switch
            >
          </b-field>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions, mapState} from 'vuex'

export default {
  data() {
    return {
      isSwitched: false,
      dataIsPushNotif: false,
      user: {},
      userId: null
    }
  },
  created() {
    this.user = this.$store.state.auth.user
        ? this.$store.state.auth.user
        : null
  },
  computed: {
    ...mapState('auth', {
      isConnected: (state) => state.isConnected,
      weakConnection: (state) => state.weakConnection
    }),
    ...mapState({
      isMessagingSupported: (state) => state.isMessagingSupported
    }),
    ...mapState('post', {
      unread_messages: (state) => state.unread_messages
    })
  },
  methods: {
    ...mapActions('auth', ['logout', 'getIsPushNotif', 'sendIsPushNotif']),
    emitDislaySidebar() {
      if (screen.width < 768) {
        this.$emit('display-sidebar', {displaySidebar: false})
      }
    },
    doLogout() {
      let path = '/'
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
      this.emitDislaySidebar()
      this.logout()
    },
    openLink(link) {
      if (this.$route.path !== link) {
        this.$router.push(link)
      } else if (link === '/') {
        location.reload()
      }
      this.emitDislaySidebar()
    },
    getDataIsPushNotif() {
      this.getIsPushNotif().then((response) => {
        if (this.user) {
          this.userId = this.user.id
        } else {
          this.userId = null
        }
        if (response.data.isNotifActivated) {
          this.dataIsPushNotif = response.data.isNotifActivated
          if (this.dataIsPushNotif) {
            this.isSwitched = true
          } else {
            this.isSwitched = false
          }
          this.$store.commit(
              'auth/setIsPushNotifActived',
              this.isSwitched
          )
        }
      })
    },
    updateIsPushNotif() {
      this.pushNotif = {value: this.isSwitched}
      this.sendIsPushNotif(this.pushNotif).catch((e) => {
        this.isSwitched = false
        this.$store.dispatch('toastError', e)
      })
    }
  }
}
</script>

<style>
.link {
  cursor: pointer;
}

.router-link-exact-active:not(#logo-sidebar) {
  color: #0070f3;
}

.router-link-exact-active:not(#logo-sidebar) i {
  color: #0070f3;
}

.switch.is-rounded input[type='checkbox'] + .check {
  width: 2.3em;
}
</style>
